module.exports = __webpack_public_path__ + "b9bc257dd462b8a4443bd57be7d40e2d.svg";